import { render, staticRenderFns } from "./Modal2.vue?vue&type=template&id=6810de35&"
import script from "./Modal2.vue?vue&type=script&lang=js&"
export * from "./Modal2.vue?vue&type=script&lang=js&"
import style0 from "./Modal2.vue?vue&type=style&index=0&id=6810de35&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports